import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styled from "@emotion/styled";

//style rules
import { Sizes, Animation } from "../../styles";

const swipeConfidenceThreshold = 5000;
const swipePower = (offset, velocity) => {
	return Math.abs(offset) * velocity;
};

const SidePanelCard = ({ content, handlePressNext, handlePressPrevious, direction }) => {
	const animationProps = {
		initial: "enter",
		animate: "center",
		exit: "exit",
		variants: Animation.cards.cardTransitionVariants,
		transition: {
			opacity: { duration: 0.2 },
			x: { type: "spring", stiffness: 300, damping: 30 },
		},
	};

	const handleDragEnd = (e, { offset, velocity }) => {
		const swipe = swipePower(offset.x, velocity.x);
		if (swipe < -swipeConfidenceThreshold) {
			handlePressNext();
		} else if (swipe > swipeConfidenceThreshold) {
			handlePressPrevious();
		}
	};

	return (
		<AnimatePresence custom={direction} exitBeforeEnter initial={false}>
			<Wrapper key={content.id} custom={direction} {...animationProps} drag="x" dragConstraints={{ left: 0, right: 0 }} dragSnapToOrigin={true} dragElastic={0.5} onDragEnd={handleDragEnd}>
				<Header>
					<HeaderTitle>{content.title}</HeaderTitle>
				</Header>
				<section className="panel-content-container" dangerouslySetInnerHTML={{ __html: content.content }} />
			</Wrapper>
		</AnimatePresence>
	);
};

export default SidePanelCard;

const Wrapper = styled(motion.div)`
	padding: 9.2rem 1.6rem 4.5;
	position: relative;
	@media only screen and (min-width: ${Sizes.screens.medium}) {
		padding: 14.2rem 10.6rem 8;
	}
`;

const Header = styled.div`
	text-align: left;
	padding-bottom: 4rem;
`;

const HeaderTitle = styled.h2`
	font-size: 3.4rem;
	line-height: 3.8rem;
	text-align: left;
`;
